import React, { forwardRef, } from "react";
import { IconButton as ChakraIconButton, Icon, useStyleConfig, } from "@chakra-ui/react";
export const IconButton = forwardRef(({ isLoading = false, icon, size = "md", variant = "tertiary", ...props }, ref) => {
    const { h } = useStyleConfig("Button", { size });
    let colorScheme;
    let chakraVariant;
    let styles;
    if (variant === "primary") {
        chakraVariant = "solid";
        colorScheme = "forest";
    }
    if (variant === "secondary") {
        chakraVariant = "outline";
        styles = {
            color: "text.secondary",
            borderColor: "base.border",
            boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
            bg: "white",
            _hover: {
                color: "text.primary",
                borderColor: "text.tertiary",
                bg: "white",
            },
            _active: {
                color: "text.primary",
                borderColor: "text.secondary",
                bg: "white",
            },
            _disabled: {
                color: "text.placeholder",
                bg: "white",
                _hover: {
                    borderColor: "base.border",
                    cursor: "not-allowed",
                },
                _active: {
                    borderColor: "base.border",
                    cursor: "not-allowed",
                },
            },
        };
    }
    if (variant === "tertiary") {
        chakraVariant = "ghost";
        styles = {
            color: "text.secondary",
            bg: "white",
            _hover: {
                color: "text.primary",
                bg: "gray.200",
            },
            _active: {
                color: "text.primary",
                bg: "gray.300",
            },
            _disabled: {
                color: "text.placeholder",
                bg: "white",
                _hover: {
                    color: "text.placeholder",
                    bg: "white",
                    cursor: "not-allowed",
                },
                _active: {
                    color: "text.placeholder",
                    bg: "white",
                    cursor: "not-allowed",
                },
            },
        };
    }
    if (variant === "danger") {
        chakraVariant = "solid";
        colorScheme = "danger";
    }
    if (variant === "warning") {
        chakraVariant = "outline";
        colorScheme = "danger";
    }
    return (React.createElement(ChakraIconButton, { ref: ref, isLoading: isLoading, icon: React.createElement(Icon, { as: icon, boxSize: size === "lg" ? 6 : 4 }), colorScheme: colorScheme, variant: chakraVariant, width: Number(h), height: Number(h), minWidth: "0", ...styles, ...props }));
});
